<template>
<div class="submit-success">
  <h4 class="center title">{{$t('registration_success')}}</h4>
  <p class="center desc">{{$t('Register.successTips1')}}</p>
  <p class="center bottom-text desc">{{email}}，{{$t('Please_review_and_activate_account')}}</p>
  <vs-button
    class="w-full mt-6"
    color="primary"
    type="filled"
    @click="backLogin"
  >{{$t('Return_to_login')}}</vs-button>
  <p class="center bot-desc">
    <span>{{$t('Activation_email_received')}}?</span>
    <span
      @click="resetSend"
      class="theme-color pointer"
    >{{$t('Register.successTips4')}}</span>
  </p>
</div>
</template>

<script>
import { getEmailAddress } from '@/utils/common';
import { mapGetters } from 'vuex'
import { retryRegActiveEmail } from '@/api/user.js'
export default {
  name: "submitSuccess",
  computed: {
    ...mapGetters(['userInfo']),
    email(){
      return this.userInfo.email;
    },
  },
  methods: {
    getEmailAddress,
    backLogin(){
      this.$router.push({name: 'login'});
    },
    jumpeEmailLink() {
      let herf = this.getEmailAddress(this.userInfo.email);
      window.open(herf, '_blank');
    },
    resetSend(){
      // 重新发送,todo
      let parmas = {
        custId:this.userInfo.id
      };
      retryRegActiveEmail(parmas).then((result) => {
        this.$message({
          message: this.$t('The_activation_email_has_been_sent_successfully_Please_go_to_the_email_to_confirm_the_activation_as_soon_as_possible_Thank_you'),
          type: 'success'
        })
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.submit-success {
  .desc {
    font-size: 14px;
  }
  .title {
    margin-bottom: 20px;
    font-weight: bold;
  }
  .bottom-text {
    //margin-bottom: 20px;
  }
  .bot-desc {
    margin-top: 20px;
  }
}
</style>
